import moment from "moment";

export function getActivityPercentageComplete(activity: any) {
  const currentDate = new Date();

  // Assuming checkDateHasPassed returns true if the start date has passed
  if (checkDateHasPassed(activity.start_date)) {
    let totalHours = getHoursBetweenDates(
      activity.start_date,
      activity.end_date
    );
    let elapsedHours = getHoursBetweenDates(activity.start_date, currentDate);

    // If the activity has not started yet
    if (elapsedHours <= 0) {
      return 0;
    }

    // Calculate the percentage of completion
    let percentageComplete = (elapsedHours / totalHours) * 100;

    // If the calculated percentage exceeds 100, cap it at 100
    if (percentageComplete > 100) {
      return 100;
    }

    // Return the floored percentage if it's below 100
    return Math.floor(percentageComplete);
  }

  // If the current date hasn't reached the start date, return 0%
  return 0;
}

export function checkDateHasPassed(date: any) {
  const currentDate = new Date();
  let current = moment(currentDate);
  let checkDate = moment(date);
  var dDiff = current.diff(checkDate);
  return dDiff > 0 ? true : false;
}

export function getHoursBetweenDates(startDate: Date, endDate: Date) {
  let start = moment(startDate);
  let end = moment(endDate);
  let duration = moment.duration(end.diff(start));
  let hours = duration.asHours();
  return hours;
}

export function getCompletedProjectActivitiesActivities(project: any) {
  if (checkDateHasPassed(project.end_date)) {
    return project.project_activities.length;
  } else {
    if (project.project_activities.length <= 0) {
      return 0;
    } else {
      return project.project_activities.filter(
        (activity: any) =>
          activity.completed || checkDateHasPassed(activity.end_date)
      ).length;
    }
  }
}
